<template>

    <div class="h-full max-h-full">

        <div class="flex align-center h-full">

            <div ref="consoleContainer"
                class="consoleContainer relative overflow-x-scroll overflow-y-scroll flex flex-row flex-grow">
                <div class="flex flex-shrink relative" style="min-width:1.5rem">
                    <vue-feather ref="caret" type="chevron-right"
                        class="h-4 w-4 text-blue-400 absolute left-0 duration-200 ease-in-out transition-all"
                        :style="'top:' + caretPosition() + 'px'"></vue-feather>
                </div>
                <div class="pb-8">


                    <table v-if="isConsoleLogs" class="console table-auto text-white font-code text-xs"
                        :key="'logs_console_' + logs.length">
                        <tbody>
                            <tr v-for="log in logs" v-bind:key="log.id"
                                v-bind:class="{ 'hoverable': log.log_level != null }">
                                <td class="px-1.5 py-1 align-top text-gray-400 rounded-l"
                                    v-bind:class="{ 'border-b border-gray-700 border-dashed': iconForLog(log) == 'repeat' && false }">
                                    <a href="#" @click.prevent="seekToTime(log.seconds)">{{ log.diff }}</a>
                                </td>
                                <td class="p-1 align-top"
                                    v-bind:class="{ 'border-b border-gray-700 border-dashed': iconForLog(log) == 'repeat' && false }">
                                    <vue-feather :type="iconForLog(log)" class="h-3 w-3 mt-0.5"
                                        v-bind:class="iconColorForLog(log)"></vue-feather>
                                </td>

                                <td v-if="log.log_level == null" class="py-1 px-2 align-top rounded-r"
                                    v-bind:class="textColorForLog(log)">
                                    <span v-if="log.misc.event == 'navigation'" class="inline-block align-top"
                                        v-html="messageForLog(log)"></span>
                                    <span v-else-if="log.misc.event == 'tab_switch'" class="inline-block align-top"
                                        v-html="messageForLog(log)"></span>
                                    <span v-else-if="log.misc.event == 'recording-start'" class="inline-block align-top" v-html="messageForLog(log)"></span>
                                    <span v-else class="inline-block align-top">{{ messageForLog(log) }}</span>
                                </td>
                                <td v-else class="py-1 px-2 align-top rounded-r" v-bind:class="textColorForLog(log)">
                                    <template v-for="message, index in log.log_message.payload"
                                        :key="'message_'+log.id+'_'+index">

                                        <span v-if="typeof message === 'object'" class="inline-block mr-2 align-top">
                                            <vue-json-pretty class="overflow-none" :deep="0" :showDoubleQuotes="false"
                                                :deepCollapseChildren="true" :data="message" />
                                        </span>
                                        <span v-else class="inline-block mr-2 align-top">{{ message }}</span>
                                    </template>
                                    <div v-if="log.log_message.trace" class="block mr-2 align-top trace">
                                        <vue-json-pretty class="overflow-none" :deep="0" :showDoubleQuotes="false"
                                            :deepCollapseChildren="true" :data="log.log_message.trace" />
                                    </div>
                                </td>

                            </tr>
                            <tr>
                                <td colspan="3" class="">&nbsp;</td>
                            </tr>

                        </tbody>
                    </table>


                    <table v-else class="console table-auto text-white font-code text-xs w-full"
                        :key="'logs_' + logs.length">
                        <tbody>
                            <tr v-for="log in logs" v-bind:key="log.id"
                                v-bind:class="{ 'hoverable': log.log_level != null }">
                                <td class="px-1.5 py-1 align-top text-gray-400 rounded-l"
                                    v-bind:class="{ 'border-b border-gray-700 border-dashed': iconForLog(log) == 'repeat' }">
                                    <a href="#" @click.prevent="seekToTime(log.seconds)">{{ log.diff }}</a>
                                </td>
                                <td class="p-1 align-top"
                                    v-bind:class="{ 'border-b border-gray-700 border-dashed': iconForLog(log) == 'repeat' }">
                                    <vue-feather :type="iconForLog(log)" class="h-3 w-3 mt-0.5"
                                        v-bind:class="iconColorForLog(log)"></vue-feather>
                                </td>

                                <td v-if="log.log_level == null" class="py-1 px-2 align-top rounded-r"
                                    v-bind:class="textColorForLog(log)">
                                    <span class="inline-block align-top">{{ messageForLog(log) }}</span>
                                </td>
                                <td v-else-if="log.is_compressed" class="py-1 px-2 align-top rounded-r"
                                    v-bind:class="textColorForLog(log)">
                                    <template v-for="message, index in decompressedLog(log.log_message)"
                                        :key="'message_'+log.id+'_'+index">
                                        <span v-if="typeof message === 'object'" class="inline-block mr-2 align-top">
                                            <vue-json-pretty class="overflow-none" :deep="0" :showDoubleQuotes="false"
                                                :deepCollapseChildren="true" :data="message" />
                                        </span>
                                        <span v-else class="inline-block mr-2 align-top">
                                            {{ message }}
                                        </span>
                                    </template>
                                </td>
                                <td v-else-if="log.log_message" class="py-1 px-2 align-top rounded-r"
                                    v-bind:class="textColorForLog(log)">
                                    <template v-for="message, index in JSON.parse(log.log_message)"
                                        :key="'message_'+log.id+'_'+index">
                                        <span v-if="typeof message === 'object'" class="inline-block mr-2 align-top">
                                            <vue-json-pretty class="overflow-none" :deep="0" :showDoubleQuotes="false"
                                                :deepCollapseChildren="true" :data="message" />
                                        </span>
                                        <span v-else class="inline-block mr-2 align-top">{{ message }}</span>
                                    </template>
                                </td>
                                <td v-else class="py-1 px-2 align-top rounded-r" v-bind:class="textColorForLog(log)">
                                    <template v-for="message, index in log" :key="'message_'+log.id+'_'+index">
                                        <span v-if="typeof message === 'object'" class="inline-block mr-2 align-top">
                                            <vue-json-pretty class="overflow-none" :deep="0" :showDoubleQuotes="false"
                                                :deepCollapseChildren="true" :data="message" />
                                        </span>
                                        <span v-else class="inline-block mr-2 align-top">{{ message }}</span>
                                    </template>
                                </td>
                            </tr>

                        </tbody>
                    </table>


                </div>

            </div>

        </div>

    </div>

</template>



<script>

// import hljs from 'highlight.js/lib/common'
// import hljsVuePlugin from "@highlightjs/vue-plugin"
// import 'highlight.js/styles/github-dark.css'

import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import LZString from "lz-string"


export default {

    props: ['logs', 'isConsoleLogs', 'maxHeight', 'start_url'],

    components: {
        // highlightjs: hljsVuePlugin.component,
        VueJsonPretty,
    },

    created: function () {
        this.EventBus.on('consoletimeupdate', (time) => {
            this.step = this.searchClosestLine(time * 1000)
            this.adjustScroll()
        })
        // if (this.$page.props.isz) {
        //     console.log("console logs", this.logs)
        // }
        // console.log(this.logs);
    },

    beforeUnmount() {
        window.removeEventListener('resize', this.setConsoleHeight);
        this.EventBus.off('consoletimeupdate');
    },

    data() {
        return {
            step: 1,
            activerow: {},
            // log_display: this.logs
        }
    },



    mounted: function () {
        //this.activerow = document.querySelector("table.console tr.active")
        // setInterval(function(){
        //     this.step++
        // }.bind(this), 1000)
        // this.build_logs()
        this.setConsoleHeight()
        //addEvent(window, "resize", this.setConsoleHeight());
        window.addEventListener('resize', this.setConsoleHeight);
    },

    methods: {
        searchClosestLine: function (ms) {
            var bestItem = 0
            var lowerdiff = 0
            var step = 0
            for (var i = 0; i < this.logs.length - 1; i++) {

                if (ms >= this.logs[i].milliseconds && ms < this.logs[i + 1].milliseconds) {
                    //console.log("ms was", ms, "found this.logs[i].milliseconds", this.logs[i].milliseconds)
                    return i + 1
                } else if (ms > this.logs[i].milliseconds) {
                    step++
                }
                // if (i == 0) {
                //     lowerdiff = Math.abs(ms - this.logs[i].milliseconds)
                //     bestItem = i
                // } else if (ms >= this.logs[i].milliseconds && Math.abs(ms - this.logs[i].milliseconds) <= lowerdiff) {
                //     lowerdiff = Math.abs(ms - this.logs[i].milliseconds)
                //     bestItem = i
                // }
            }
            //return bestItem + 1
            return step + 1
        },
        seekToTime: function (time) {
            this.EventBus.emit("videoseek", time)
        },
        setConsoleHeight: function () {

            if (this.$refs.consoleContainer) {
                const maxHeight = window.innerHeight - this.$refs.consoleContainer.getBoundingClientRect().top - 10
                this.$refs.consoleContainer.style.maxHeight = maxHeight + "px"
            }

        },
        iconForLog: function (log) {
            if (log.log_level == "error") {
                return "x-circle"
            } else if (log.log_level == "warn") {
                return "alert-triangle"
            } else if (log.log_level != null) {
                return "chevron-right"
            } else if (log.log_level == null && log.misc != null) {

                if (log.misc.event) {
                    if (log.misc.event == 'click') {
                        return "mouse-pointer"
                    } else if (log.misc.event == 'blur') {
                        return "eye-off"
                    } else if (log.misc.event == 'focus') {
                        return "eye"
                    } else if (log.misc.event == 'tab-switch') {
                        return "repeat"
                    } else if (log.misc.event == 'navigation') {
                        return "navigation"
                    } else if (log.misc.event == 'tab_switch') {
                        return "repeat"
                    } else if (log.misc.event == 'recording-start') {
                        return "play"
                    } else if (log.misc.event == 'recording-stop') {
                        return "square"
                    } else if (log.misc.event == 'recorder-pause') {
                        return "pause"
                    } else if (log.misc.event == 'recorder-resume') {
                        return "play"
                    } else if (log.misc.event == 'debugger-detached') {
                        return "x"
                    }
                }

            }
        },
        iconColorForLog: function (log) {
            if (log.log_level == "error") {
                return "text-red-500"
            } else if (log.log_level == "warn") {
                return "text-yellow-400"
            } else if (log.log_level != null) {
                return "text-transparent"
            } else if (log.log_level == null && log.misc != null) {
                if (log.misc.event) {
                    return "text-blue-400"
                }
            }
        },
        textColorForLog: function (log) {
            if (log.log_level == "error") {
                return "text-red-500"
            } else if (log.log_level == "warn") {
                return "text-yellow-400"
            } else if (log.log_level != null) {
                return "text-white"
            } else if (log.log_level == null && log.misc != null) {
                if (log.misc.event) {
                    if (log.misc.event == 'tab-switch') {
                        return "text-gray-500 border-b border-gray-700 border-dashed"
                    } else if (log.misc.event == 'recorder-resume') {
                        return "text-gray-500 border-t border-gray-700 border-dashed"
                    } else if (log.misc.event == 'debugger-detached') {
                        return "text-blue-400"
                    } else {
                        return "text-gray-500"
                    }
                }
            }
        },
        decompressedLog: function (log_message) {
            return JSON.parse(LZString.decompressFromEncodedURIComponent(log_message))
        },
        messageForLog: function (log) {
            if (log.misc != null) {
                //const data = JSON.parse(log.misc)
                var message = ""
                if (log.misc.event) {
                    message = log.misc.event + " "
                    if (log.misc.event == "click") {
                        message = "Clicked on"
                        if (log.misc.message) {
                            message += " " + log.misc.message
                        }
                    } else if (log.misc.event == 'navigation') {
                        message = "Navigation to <a href='" + log.misc.to + "' target='_blank' class='hover:underline'>" + log.misc.to + "</a>"
                    } else if (log.misc.event == 'tab_switch') {
                        message = "Change tab to <a href='" + log.misc.to + "' target='_blank' class='hover:underline'>" + log.misc.to + "</a>"
                    } else if (log.misc.event == "tab-switch") {
                        message = "Tab switch"
                    } else if (log.misc.event == "blur") {
                        message = "Document focus lost"
                    } else if (log.misc.event == "debugger-detached") {
                        message = "Logs capture stopped " + log.misc.reason
                    } else if (log.misc.event == "focus") {
                        message = "Document focus"
                    } else if (log.misc.event == 'recording-start') {
                        message = "Recording started"
                        if (this.start_url && this.start_url.startsWith("http")) {
                            message += " at <a href='" + this.start_url + "' target='_blank' class='hover:underline'>" + this.start_url + "</a>"
                        }
                    } else if (log.misc.event == 'recording-stop') {
                        message = "Recording stopped"
                    } else if (log.misc.event == 'recorder-pause') {
                        message = "Recording paused"
                    } else if (log.misc.event == 'recorder-resume') {
                        message = "Recording resumed"
                        if (log.misc.message) {
                            if (log.misc.message.paused_for) {
                                if (log.misc.message.paused_for > 0) {
                                    if (log.misc.message.paused_for < 1000) {
                                        message += " after less than a second of pause"
                                    } else {
                                        message += " after " + this.formatTime(log.misc.message.paused_for) + " of pause"
                                    }
                                }
                            }
                        }
                    }
                    // else if (log.misc.event == 'cobrowsing-start') {
                    //     message = "Cobrowsing started"
                    // } else if (log.misc.event == 'cobrowsing-stop') {
                    //     message = "Cobrowsing stopped"
                    // }
                }
                if (message == "" && log.misc.message) {
                    message = log.misc.message
                }
                return message
            }
            return ""
        },
        // build_logs: function() {
        //     this.log_display = this.logs
        // },
        caretPosition: function () {
            const active_step = this.step
            this.activerow = document.querySelector(`table.console tr:nth-child(${active_step})`)
            if (this.activerow != null) {
                const rect = this.activerow.getBoundingClientRect()
                const rect_parent = document.querySelector(`table.console`).getBoundingClientRect()
                return rect.top - rect_parent.top + 4.7
            }
            return 4.7
        },
        adjustScroll: function () {
            if (!this.$refs.consoleContainer) {
                return
            }
            const consoleHeight = window.innerHeight - this.$refs.consoleContainer.getBoundingClientRect().top - 10
            const caret_y = this.caretPosition()
            const consoleScroll = this.$refs.consoleContainer.scrollTop
            //this.$refs.caret.scrollIntoView({ behavior: 'smooth', block: 'end'});
            //return
            if (caret_y - consoleScroll < 5) {
                this.$refs.consoleContainer.scrollTop = caret_y - 5
            } else if (caret_y - consoleScroll > consoleHeight - 20) {
                this.$refs.consoleContainer.scrollTop = caret_y - consoleHeight + consoleHeight / 2
            }
        },

        formatTime(ms) {
            // Convert milliseconds to seconds
            let totalSeconds = Math.floor(ms / 1000);

            // Calculate hours, minutes, and seconds
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            // Format hours, minutes, and seconds with leading zeroes
            const formattedMinutes = minutes.toString().padStart(2, '0');
            const formattedSeconds = seconds.toString().padStart(2, '0');

            // Return appropriate format based on duration
            if (hours > 0) {
                const formattedHours = hours.toString().padStart(2, '0');
                return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
            } else {
                return `${formattedMinutes}:${formattedSeconds}`;
            }
        },

        sanitizeHtml(html) {
            // If the message contains HTML tags, ensure they're properly rendered
            if (html && html.includes('<') && html.includes('>')) {
                return html;
            }
            return html;
        }
    },

    computed: {

    }
}

</script>

<style>
.vjs-tree {
    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
    font-size: 12px;
}

.vjs-tree__node.is-highlight,
.vjs-tree__node:hover {
    background-color: rgba(255, 255, 255, 0.02);
}

.vjs-tree__node .vjs-tree__indent.has-line {
    border-left: 1px dashed rgb(55, 65, 81);
}

.vjs-value__string {
    word-wrap: anywhere;
}
</style>
<style scoped>
.font-code {
    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
}

table tbody tr.hoverable:hover td {
    background: rgba(255, 255, 255, 0.026);
}

.consoleContainer {
    scroll-behavior: smooth;
}


.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}
</style>
